import React from "react";
import NavBar from "./components/NavBar";
import Mains from "./pages/Mains";
import Footer from "./components/Footer";
import Legal from "./pages/Legal";
import GlobalStyles from "./components/GlobalStyles";
import { Route, Routes } from "react-router-dom";

const App = () => {
  return (
    <div>
      <GlobalStyles />
      <NavBar />
      <Routes>
        <Route
          path="/"
          element={<Mains />}
        />
        <Route
          path="/legal"
          element={<Legal />}
        />
      </Routes>
      <Footer />
    </div>
  );
};

export default App;
